/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import { css } from "styled-components";

myListsEditListFormStyles.container = {
    gap: 15,
};

myListsEditListFormStyles.buttonsGridItem = {
    width: 12,
    css: css`
        &&& {
            width: 100%;
            justify-content: flex-end;
            margin-top: 15px;
        }
    `,
};

createUserModalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        &&& {
            justify-content: flex-end;
            margin-top: 15px;
        }
    `,
};

customerAddressFormFieldStyles.container = {
    gap: 15,
};
